// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__20WyT","title":"AfterBackImages_title__3tULP","images":"AfterBackImages_images__AqWzo"};